// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IKOOd","footer":"styles_footer__3iJSr","passCodeTooltip":"styles_passCodeTooltip__D5xqv"};